var render = function render(_c, _vm) {
  return _c(
    "svg",
    {
      class: [_vm.data.class, _vm.data.staticClass],
      attrs: { xmlns: "http://www.w3.org/2000/svg" },
    },
    [_c("use", { attrs: { href: _vm.props.icon } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }